const stack = {
    eyebrow: 'טכנולוגיות',
    title: 'הכלים שאני עובד איתם',
    description: 'הכלים שאני משתמש בהם ביום-יום, מסודרים לפי המקום שלהם במערכת.',
};

export default stack;
